import { render, staticRenderFns } from "./downloadModel.vue?vue&type=template&id=b6d39ade&scoped=true"
import script from "./downloadModel.vue?vue&type=script&lang=js"
export * from "./downloadModel.vue?vue&type=script&lang=js"
import style0 from "./downloadModel.vue?vue&type=style&index=0&id=b6d39ade&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d39ade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6d39ade')) {
      api.createRecord('b6d39ade', component.options)
    } else {
      api.reload('b6d39ade', component.options)
    }
    module.hot.accept("./downloadModel.vue?vue&type=template&id=b6d39ade&scoped=true", function () {
      api.rerender('b6d39ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/modelForm/downloadModel.vue"
export default component.exports